import { Injectable, TemplateRef } from "@angular/core";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { UiNotificationDataOptions, UiNotificationRef } from "@webapp/ui/notification/notification.models";
import { fillDataOptionsNzValues } from "@webapp/ui/notification/util/notification.util";

@Injectable()
export class UiNotificationService extends NzNotificationService {
  public success(title: string, content: string, options?: UiNotificationDataOptions): UiNotificationRef {
    return super.success(title, content, fillDataOptionsNzValues(options));
  }

  public error(title: string, content: string, options?: UiNotificationDataOptions): UiNotificationRef {
    return super.error(title, content, fillDataOptionsNzValues(options));
  }

  public info(title: string, content: string, options?: UiNotificationDataOptions): UiNotificationRef {
    return super.info(title, content, fillDataOptionsNzValues(options));
  }

  public warning(title: string, content: string, options?: UiNotificationDataOptions): UiNotificationRef {
    return super.warning(title, content, fillDataOptionsNzValues(options));
  }

  public blank(title: string, content: string, options?: UiNotificationDataOptions): UiNotificationRef {
    return super.blank(title, content, fillDataOptionsNzValues(options));
  }

  public remove(messageId?: string): void {
    super.remove(messageId);
  }

  public create(
    type: "success" | "info" | "warning" | "error" | "blank" | string,
    title: string,
    content: string,
    options?: UiNotificationDataOptions
  ): UiNotificationRef {
    return super.create(type, title, content, fillDataOptionsNzValues(options));
  }

  public template(template: TemplateRef<object>, options?: UiNotificationDataOptions): UiNotificationRef {
    return super.template(template, fillDataOptionsNzValues(options));
  }
}
